import { FinderActionsBodyCell } from './FinderActionsBodyCell';
import { useActionsColumn } from '../../../../../../../../components/columns/actions';

export function useFinderActionsColumn() {
  return useActionsColumn({
    render: (text, row) => <FinderActionsBodyCell row={row} />,
  });
}
